var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNephrology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09277,
    y: 0.5,
    width: 72.8042,
    height: 72.8042,
    rx: 7.5,
    stroke: "#222222",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9741 42.2504C14.0719 37.0038 18.0393 20.0947 25.4961 17.4343C28.5893 16.3307 32.0937 20.2622 32.1141 22.661C32.1344 25.0597 29.6092 27.2702 30.184 30.247C30.7587 33.2236 31.4323 38.2406 29.9666 40.5869C28.5008 42.9334 26.9901 43.2206 24.9741 42.2504Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7676 34.8663C31.7676 34.8663 31.7697 34.8663 31.8088 33.4778C31.8479 32.0894 31.85 32.0894 31.85 32.0894L31.8522 32.0895L31.8566 32.0896L31.8662 32.09L31.888 32.091C31.9037 32.0919 31.9215 32.093 31.9416 32.0946C31.9816 32.0978 32.0305 32.1028 32.0871 32.1107C32.1995 32.1263 32.3447 32.1535 32.5118 32.2013C32.8451 32.2966 33.2796 32.478 33.7109 32.8233C34.6286 33.5581 35.2749 34.8195 35.2749 36.7594V57.091H32.5153V36.7594C32.5153 35.4773 32.1185 35.0978 31.9931 34.9974C31.9027 34.925 31.8157 34.8902 31.7578 34.8736C31.7293 34.8654 31.71 34.8627 31.71 34.8627C31.71 34.8627 31.7134 34.8632 31.7229 34.8639L31.7416 34.8652L31.7544 34.8657L31.7617 34.866L31.7657 34.8661L31.7676 34.8663Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5737 42.2504C59.476 37.0038 55.5085 20.0947 48.0517 17.4343C44.9585 16.3307 41.4541 20.2622 41.4337 22.661C41.4134 25.0597 43.9386 27.2702 43.3638 30.247C42.7891 33.2236 42.1155 38.2406 43.5812 40.5869C45.047 42.9334 46.5577 43.2206 48.5737 42.2504Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7796 34.8663C41.7796 34.8663 41.7777 34.8663 41.7385 33.4778C41.6993 32.0894 41.6972 32.0894 41.6972 32.0894L41.6952 32.0895L41.6906 32.0896L41.6811 32.09L41.6593 32.091C41.6437 32.0919 41.6258 32.093 41.6058 32.0946C41.5656 32.0978 41.5168 32.1028 41.4603 32.1107C41.3477 32.1263 41.2026 32.1535 41.0355 32.2013C40.7021 32.2966 40.2676 32.478 39.8365 32.8233C38.9188 33.5581 38.2725 34.8195 38.2725 36.7594V57.091H41.032V36.7594C41.032 35.4773 41.4289 35.0978 41.5543 34.9974C41.6447 34.925 41.7317 34.8902 41.7895 34.8736C41.818 34.8654 41.8374 34.8627 41.8374 34.8627C41.8374 34.8627 41.834 34.8632 41.8245 34.8639L41.8057 34.8652L41.7929 34.8657L41.7855 34.866L41.7817 34.8661L41.7796 34.8663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNephrology);
export default __webpack_public_path__ + "static/media/nephrology.6f0a46bfb08ab4a27afd3f233efcf31d.svg";
export { ForwardRef as ReactComponent };